__turbopack_context__.v({
  "mark": "Slider-module-scss-module__CCcJ5q__mark",
  "rail": "Slider-module-scss-module__CCcJ5q__rail",
  "reset-marker": "Slider-module-scss-module__CCcJ5q__reset-marker",
  "slider": "Slider-module-scss-module__CCcJ5q__slider",
  "slider-container": "Slider-module-scss-module__CCcJ5q__slider-container",
  "thumb": "Slider-module-scss-module__CCcJ5q__thumb",
  "track": "Slider-module-scss-module__CCcJ5q__track",
  "value-label": "Slider-module-scss-module__CCcJ5q__value-label",
  "value-label-shape": "Slider-module-scss-module__CCcJ5q__value-label-shape",
  "value-label-value": "Slider-module-scss-module__CCcJ5q__value-label-value",
});
